<div class="flex flex-row gap-(--gap-normal)">
  <div class="w-64 pr-(--space-4)">
    <div class="mb-(--space-4) flex justify-start items-center">
      <ces-button-secondary
        [hasPermission]="writePermission()"
        [label]="'common.buttons.add' | transloco"
        size="small"
        icon="add"
        (onClick)="createChecker()" />
    </div>
    <div class="overflow-y-auto">
      @if (measureCheckers().length > 0) {
        <ul class="list-none p-0 m-0">
          @for (checker of measureSortedCheckers(); track checker.id) {
            <li>
              <a
                [routerLink]="[]"
                [fragment]="'checker-' + checker.id"
                class="block bg-transparent p-(--space-2) transition-colors border-y-0 border-r-0 border-l-2"
                [ngClass]="{
                  'border-l-orange-500 text-orange-500': selectedCheckerId() === checker.id,
                  'border-l-gray-200 text-(color:--text-primary)': selectedCheckerId() !== checker.id,
                  'hover:border-l-orange-400 hover:text-orange-500': true,
                  'checker-current': isCurrentChecker(checker),
                }"
                (click)="selectChecker(checker.id)">
                <div class="flex flex-col">
                  <span class="text-sm flex flex-row items-start gap-(--gap-tight)">
                    {{ getCheckerFromDate(checker.startTs) }}
                    @if (t.testMode()) {
                      <span>#{{ checker.id }}</span>
                    }
                  </span>
                  @if (checker.comment) {
                    <span class="text-xs text-(color:--text-secondary) mt-(--space-1) truncate">{{ checker.comment }}</span>
                  } @else {
                    <span class="font-medium text-xs text-(color:--text-secondary)">{{ getCheckerTypeName(checker.type) }}</span>
                  }
                </div>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </div>

  <div class="flex-1 bg-(--surface-2) p-(--padding-card) rounded-(--radius-lg)">
    @if (measureCheckers().length > 0) {
      @if (selectedChecker(); as checker) {
        <div class="flex items-start gap-(--gap-normal)">
          <div class="flex-1 flex flex-col gap-(--gap-loose)">
            <div class="flex flex-row gap-(--gap-relaxed)">
              <div class="flex w-1/2 flex-col">
                <ces-property [label]="'forms.validityStart' | transloco">{{
                  checker.startTs | date: 'dd.MM.yyyy HH:mm'
                }}</ces-property>
                @if (t.testMode()) {
                  <div class="text-(color:--text-primary) text-xs">Début : {{ checker.startTs }}</div>
                  <div class="text-(color:--text-primary) text-xs">Fin : {{ checker.endTs }}</div>
                }
              </div>
              <div class="flex w-1/2 flex-col">
                <ces-property [label]="'common.labels.verificationType' | transloco">{{
                  getCheckerTypeName(checker.type)
                }}</ces-property>
              </div>
            </div>

            @if (checker.type === CheckerType.TWO_FIXED_LIMITS) {
              <div class="flex flex-row gap-(--gap-relaxed)">
                <div class="flex flex-col w-1/2">
                  <ces-property [label]="'forms.lowerBound' | transloco">{{ checker.negativeGap }}</ces-property>
                </div>
                <div class="flex flex-col w-1/2">
                  <ces-property [label]="'forms.upperBound' | transloco">{{ checker.positiveGap }}</ces-property>
                </div>
              </div>
            } @else if (checker.type === CheckerType.TWO_POLYNOMIALS) {
              <p-tabs value="tab1">
                <p-tablist>
                  <p-tab value="tab1">{{ 'forms.lowerPolynomial' | transloco }}</p-tab>
                  <p-tab value="tab2">{{ 'forms.upperPolynomial' | transloco }}</p-tab>
                </p-tablist>
                <p-tabpanels>
                  <p-tabpanel value="tab1">
                    @if (checker.formulaFirst) {
                      <div>
                        <div class="select-none text-label mb-(--space-1)">{{ 'common.labels.parameters' | transloco }}</div>
                        <ces-parameters-display
                          [parametersInput]="checker.formulaFirst.parameters"
                          [unitsInput]="units()"
                          [measuresInput]="measures()"
                          [mode]="ParameterMode.POLYNOMIAL"
                          [title]="'common.labels.parameters' | transloco"
                          [emptyMessage]="'entities.measureChecker.messages.emptyPolynomialParams' | transloco" />
                      </div>

                      <div>
                        <div class="select-none text-label mb-(--space-1)">{{ 'common.labels.expression' | transloco }}</div>
                        <ces-expression-display [formula]="checker.formulaFirst" />
                      </div>
                    } @else {
                      <div class="p-(--padding-card) text-center mb-(--space-4)">
                        <p>{{ 'entities.measureChecker.messages.noPolynomialDefined' | transloco }}</p>
                      </div>
                    }
                  </p-tabpanel>
                  <p-tabpanel value="tab2">
                    @if (checker.formulaSecond) {
                      <div>
                        <div class="select-none text-label mb-(--space-1)">{{ 'common.labels.parameters' | transloco }}</div>
                        <ces-parameters-display
                          [parametersInput]="checker.formulaSecond.parameters"
                          [unitsInput]="units()"
                          [measuresInput]="measures()"
                          [mode]="ParameterMode.POLYNOMIAL"
                          [title]="'common.labels.parameters' | transloco"
                          [emptyMessage]="'entities.measureChecker.messages.emptyPolynomialParams' | transloco" />
                      </div>

                      <div>
                        <div class="select-none text-label mb-(--space-1)">{{ 'common.labels.expression' | transloco }}</div>
                        <ces-expression-display [formula]="checker.formulaSecond" />
                      </div>
                    } @else {
                      <div class="p-(--padding-card) text-center mb-(--space-4)">
                        <p>{{ 'entities.measureChecker.messages.noPolynomialDefined' | transloco }}</p>
                      </div>
                    }
                  </p-tabpanel>
                </p-tabpanels>
              </p-tabs>
            } @else if (checker.type === CheckerType.POLYNOMIAL_AND_RANGES) {
              <p-tabs value="poly">
                <p-tablist>
                  <p-tab value="poly">{{ 'forms.polynomial' | transloco }}</p-tab>
                  <p-tab value="gap">{{ 'forms.gapRanges' | transloco }}</p-tab>
                </p-tablist>
                <p-tabpanels>
                  <p-tabpanel value="poly">
                    @if (checker.formulaFirst) {
                      <div>
                        <div class="select-none text-label mb-(--space-1)">{{ 'common.labels.parameters' | transloco }}</div>
                        <ces-parameters-display
                          [parametersInput]="checker.formulaFirst.parameters"
                          [unitsInput]="units()"
                          [measuresInput]="otherMeasures()"
                          [mode]="ParameterMode.POLYNOMIAL"
                          [title]="'common.labels.parameters' | transloco"
                          [emptyMessage]="'entities.measureChecker.messages.emptyPolynomialParams' | transloco" />
                      </div>

                      <div>
                        <div class="select-none text-label mb-(--space-1)">{{ 'common.labels.expression' | transloco }}</div>
                        <ces-expression-display [formula]="checker.formulaFirst" />
                      </div>
                    } @else {
                      <div class="p-(--padding-card) text-center mb-(--space-4)">
                        <p>{{ 'entities.measureChecker.messages.noPolynomialDefined' | transloco }}</p>
                      </div>
                    }
                  </p-tabpanel>
                  <p-tabpanel value="gap">
                    <div class="flex flex-row gap-(--gap-relaxed)">
                      <div class="flex flex-col w-1/2">
                        <ces-property [label]="'forms.negativeGap' | transloco">{{ checker.negativeGap }}</ces-property>
                      </div>
                      <div class="flex flex-col w-1/2">
                        <ces-property [label]="'forms.positiveGap' | transloco">{{ checker.positiveGap }}</ces-property>
                      </div>
                    </div>
                  </p-tabpanel>
                </p-tabpanels>
              </p-tabs>
            }
          </div>
          <div class="shrink-0 flex flex-col gap-(--gap-normal)">
            <ces-button-secondary
              [hasPermission]="writePermission()"
              [label]="'common.buttons.edit' | transloco"
              size="small"
              icon="edit"
              (onClick)="editChecker(checker)" />
            @if (t.testMode()) {
              <ces-delete-button
                size="small"
                [label]="'common.buttons.delete' | transloco"
                (confirm)="deleteChecker(checker)"
                [confirmationConfig]="getCheckerDeleteConfig(checker)" />
            }
          </div>
        </div>
      } @else {
        <div class="flex flex-col items-center justify-center align-middle h-full">
          {{ 'entities.measureChecker.messages.selectFromList' | transloco }}
        </div>
      }
    } @else {
      <div class="flex flex-col items-center justify-center align-middle h-full">
        {{ 'entities.measureChecker.messages.noneFound' | transloco }}
      </div>
    }
  </div>
</div>
